import FreeWorkoutForm from '../components/FreeWorkoutForm'
import Layout from "../components/layout"
import React from "react"
import SEO from "../components/seo"
import styles from "../styles/freeworkout.module.scss"

//Static FreeWorkout Page
const FreeWorkout = () => (
  <Layout>
        <SEO title="Free Workout" />
  <main className={styles.main}>
  <div className={styles.img}>
  </div>
    <div className={styles.form}>
  <h1>This is a place for us all. </h1>
  <p>Join this community and receive a free workout!</p>
  <FreeWorkoutForm />
  <p>We respect your email privacy!</p>
  </div>
  </main>
  </Layout>
)

export default FreeWorkout
